import {
  DayOffsRequest,
  DayOffsResponseCancel,
  RejectDayOffRequest,
  TakeToWorkInfo,
  TDayOffResponseCanceled,
} from 'shared/types/dayoff.types';
import { edpApiV1 } from './index';

export const cancelDayoffApi = edpApiV1.injectEndpoints({
  endpoints: build => ({
    dayoffsCanceled: build.query<DayOffsResponseCancel, DayOffsRequest>({
      query: payload => ({ url: '/v1/admin/hr/time-off-canceled/requests', method: 'GET', params: payload }),
      providesTags: ['dayoffCanceled'],
    }),
    singleDayoffCanceled: build.query<
      TDayOffResponseCanceled,
      { id: number | string; allAvailableOrganizations: boolean }
    >({
      query: ({ id, allAvailableOrganizations }) => ({
        url: `/v1/admin/hr/time-off-canceled/requests/${id}`,
        method: 'GET',
        params: { allAvailableOrganizations },
      }),
      providesTags: ['dayoffCanceled'],
    }),
    approveDayoffCanceled: build.mutation<string, number>({
      query: id => ({ url: `/v1/admin/hr/time-off-canceled/requests/${id}/approve`, method: 'POST' }),
      invalidatesTags: ['dayoffCanceled'],
    }),
    rejectDayoffCanceled: build.mutation<string, RejectDayOffRequest>({
      query: ({ requestId, ...body }) => ({
        url: `/v1/admin/hr/time-off-canceled/requests/${requestId}/reject`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['dayoffCanceled'],
    }),
    takeToWorkDayOffCanceled: build.mutation<unknown, TakeToWorkInfo>({
      query: ({ requestId }) => ({
        url: `/v1/admin/hr/time-off-canceled/requests/${requestId}/take-to-work`,
        method: 'POST',
      }),
      invalidatesTags: ['dayoffCanceled'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useApproveDayoffCanceledMutation,
  useDayoffsCanceledQuery,
  useLazyDayoffsCanceledQuery,
  useLazySingleDayoffCanceledQuery,
  useRejectDayoffCanceledMutation,
  useSingleDayoffCanceledQuery,
  useTakeToWorkDayOffCanceledMutation,
} = cancelDayoffApi;
